import { INewbuilding } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';

export const getNewbuildingPromoSnippetNewbuilding = (state: IApplicationState): INewbuilding | undefined => {
  return state.offersData.newbuildingPromoSnippet?.newbuilding;
};
